export default __webpack_public_path__ + "static/media/Latest.c92680fe.png";